<kodit-dropdown
  [options]="items"
  [formCtrl]="formCtrl"
  ctrlTooltip="Izaberite pravilo"
  ctrlTooltipPosition="top"
  (optionChanged)="handleItemChange($event)"
></kodit-dropdown>

